import { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import React from 'react'
import RhfCheck from './RhfCheck';
import { RhfProps } from './types/RhfProps';
import { RhfStyleProps } from './types/RhfStyleProps';
import Label from './ui/Label';

// Omit: 排除 type 指定屬性  & Omit<FormControlLabelProps, "control">

type Props = RhfProps & RhfStyleProps & {
    label: React.ReactNode;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;

    markProps?: CheckboxProps;
    formControlLabelProps?: FormControlLabelProps
}

/**
 * 等於 MUI.Checkbox + 文字標籤
 */
const RhfCheckBox = ({ rhf, name, defaultValue, rules, // RhfProps
    sx, className, style,// RhfStyleProps
    label,
    onChange,

    markProps,
    formControlLabelProps,
    ...restProps
}: Props) => {

    if (sx == null) {
        sx = { marginRight: 3 } // 右側稍微留白
    }

    return (
        <FormControlLabel
            {...formControlLabelProps}
            sx={sx} className={className} style={style}
            label={(typeof (label) === "string" ? <Label text={label} /> : label)}
            control={
                <RhfCheck {...markProps}
                    rhf={rhf} name={name} defaultValue={defaultValue} rules={rules}
                    onChange={onChange}
                />
            }
        />
    )
}

export default RhfCheckBox